import React, { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';

import * as cafeActions from '../../../redux/cafes/actions';

import DatePicker from '../../../components/FormElements/DatePicker/DatePicker';

const ReserveDaysListFilter = props => {
  let formRefrence = useRef();
  let [startDate, setStartDate] = useState(' ');
  let [endDate, setEndDate] = useState(' ');
  let [cafeNamePart, setCafeNamePart] = useState();
  let [cafeIds, setCafeIds] = useState();

  useEffect(() => {
    props.getAllCafeNamesForPanel();
  }, []);

  const resetForm = event => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = null;
      } else if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setStartDate(' ');
    setEndDate(' ');
    setCafeIds(null);
    setCafeNamePart('');
    props.applyFilters(event);
  };

  return (
    <article>
      <form
        ref={formRefrence}
        onReset={event => resetForm(event)}
        onSubmit={event => props.applyFilters(event)}
        id="filterForm"
        className="card card my-4"
      >
        <header className="text-center card-header">
          <h5 className="font-italic text-muted">{locales('titles.filter')}</h5>
        </header>
        <main className="card-body">
          <div
            className="d-flex flex-sm-column col-12 flex-md-row justidy-content-between px-1"
            style={{ gap: '3px' }}
          >
            <div
              className="d-flex col-md-7 col-sm-12 justify-content-between mx-1"
              style={{ gap: '5px' }}
            >
              <DatePicker
                marge={true}
                placeholder="تاریخ شروع"
                name="fromDate"
                onChange={d => setStartDate(d)}
                value={startDate}
                className="col-6 date-picker-input"
              />
              <DatePicker
                marge={true}
                placeholder="تاریخ پایان"
                name="toDate"
                onChange={d => setEndDate(d)}
                value={endDate}
                className="col-6 date-picker-input"
              />
            </div>
            {props.meInfo.selectedRole.type == 'ADMIN' && (
              <div className="col-md-5 col-sm-12 d-flex align-items-center">
                <Select
                  id="cafeIds"
                  name="cafeIds"
                  isMulti={true}
                  value={cafeIds}
                  onChange={selectedCafeIds => {
                    setCafeIds(selectedCafeIds);
                    props.onSelectCafeIds(selectedCafeIds);
                  }}
                  className="col-12 mx-1"
                  options={props.cafeNamesList.map(n => ({
                    label: n.name,
                    value: n.id
                  }))}
                  placeholder={locales('fields.cafe.name')}
                />
              </div>
            )}
          </div>

          <div className="col-12 d-flex justify-content-end p-0 my-3">
            <input
              name="resetButton"
              type="reset"
              value={locales('fields.reset')}
              className="btn btn-danger w-5 mx-2"
            />
            <button
              type="submit"
              id="apply-filter-btn-reservationDay"
              className="btn btn-success w-5 mx-2"
            >
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </article>
  );
};

const mapStateToProps = state => {
  const meInfo = state.authReducer.meInfo;

  return {
    meInfo,
    cafeNamesLoading: state.cafesReducer.cafeNamesLoading,
    cafeNamesList: state.cafesReducer.cafeNamesList,
    cafeNamest: state.cafesReducer.cafeNames,
    cafeNamesFailed: state.cafesReducer.cafeNamesFailed,
    cafeNamesMessage: state.cafesReducer.cafeNamesMessage,
    cafeNamesError: state.cafesReducer.cafeNamesError,

    cafeNamesListLoading: state.cafesReducer.cafeNamesListLoading,
    cafeNamesList: state.cafesReducer.cafeNamesList,
    cafeNamesList: state.cafesReducer.cafeNamesList,
    cafeNamesListFailed: state.cafesReducer.cafeNamesListFailed,
    cafeNamesListMessage: state.cafesReducer.cafeNamesListMessage,
    cafeNamesListError: state.cafesReducer.cafeNamesListError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAllCafeNamesForPanel: () => dispatch(cafeActions.getAllCafeNamesForPanel())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReserveDaysListFilter);
